import Vue from 'vue'
import Vuex from 'vuex'
import Cookies from 'js-cookie'

Vue.use(Vuex);

const LOGIN = 'LOGIN';
const PUSH_ERROR = 'PUSH_ERROR';
const DELETE_ERROR = 'DELETE_ERROR';
const CLEAR_ERRORS = 'CLEAR_ERRORS';
const LOGOUT = 'LOGOUT';
const CLEAR_LAST_SEARCH = 'CLEAR_LAST_SEARCH';
const SET_LAST_SEARCH = 'SET_LAST_SEARCH';
const SET_NEXT_ROUTE = 'SET_NEXT_ROUTE';
const SET_OVERLAY = 'SET_OVERLAY';
const SET_CURRENT_USER = 'SET_CURRENT_USER';

let jwtDecode = require('jwt-decode');

export default new Vuex.Store({
	state: {
		token: Cookies.get('token'),
		errors: [],
		lastSearchCriteria: {},
		nextRoute: null,
		overlay: false
	},
	mutations: {
		[SET_CURRENT_USER](state, username) {
			state.username = username;
		},
		[SET_NEXT_ROUTE](state, route) {
			state.nextRoute = route;
		},
		[SET_OVERLAY](state, overlay) {
			state.overlay = overlay;
		},
		[LOGIN](state, token) {
			state.token = token;
			Cookies.set('token', token, { secure: false })
		},
		[PUSH_ERROR](state, error) {
			state.errors.push(error)
		},
		[DELETE_ERROR](state, errorIndex) {
			state.errors.splice(errorIndex, 1)
		},
		[SET_LAST_SEARCH](state, {entity, criteria}) {
			Vue.set(state.lastSearchCriteria, entity, criteria)
		},
		[CLEAR_LAST_SEARCH](state) {
			Vue.set(state, 'lastSearchCriteria', {})
		},
		[CLEAR_ERRORS](state) {
			Vue.set(state, 'errors', [])
		},
		[LOGOUT](state) {
			state.token = '';
			Cookies.remove('token')
		}
	},
	getters: {
		get_token: state => {
			return state.token === undefined ? '' : state.token
		},
		get_overlay: state => {
			return state.overlay === undefined ? false : state.overlay
		},
		get_errors: state => {
			return state.errors === undefined ? [] : state.errors
		},
		get_next_route: state => {
			return state.nextRoute
		},
		get_success: state => {
			return state.success === undefined ? '' : state.success
		},
		get_username: state => {
			return state.token ? jwtDecode(state.token).username : ''
		},
		get_is_data_entry_user: (state, getters) => {
			return false;
			/*let username = getters.get_username.substring(0, 3)
			return username === 'MD1' || username === 'MD2' || username === 'MD3'*/
		},
		get_parent_organization: state => {
			return state.token ? JSON.parse(jwtDecode(state.token).access).parentOrganization : ''
		},
		get_access_privileges: state => {
			return state.token ? JSON.parse(jwtDecode(state.token).access).privileges : ''
		},
		get_last_search: state => {
			return state.lastSearchCriteria === undefined ? [] : state.lastSearchCriteria
		}
	},
	actions: {
		login({commit}, token) {
			commit(LOGIN, token)
		},
		push_error({commit}, error) {
			commit(PUSH_ERROR, error)
		},
		clear_errors({commit}) {
			commit(CLEAR_ERRORS)
		},
		delete_error({commit}, index) {
			commit(DELETE_ERROR, index)
		},
		clear_last_search({commit}) {
			commit(CLEAR_LAST_SEARCH)
		},
		set_next_route({commit}, route) {
			commit(SET_NEXT_ROUTE, route)
		},
		set_overlay({commit}, overlay) {
			commit(SET_OVERLAY, overlay)
		},
		set_last_search({commit}, {entity, criteria}) {
			commit(SET_LAST_SEARCH, {entity, criteria})
		},
		logout({commit}) {
			return new Promise((resolve) => {
				commit(LOGOUT);
				resolve()
			})
		},
	}
})
